import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../Field'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { ButtonSelect } from '../../../../Select'
import { DOC_FLOW_FORM_FIELD_TYPE } from '../../../DocFlow.constants'
import { useDocFlowContext } from '../../../DocFlow.hooks'
import { getDocFlowMappingTypeOptions } from '../../../DocFlow.utils.mapping'
import { getPagesOverlimitTooltip } from '../../../DocFlowUploading'

function DocFlowMappingTypeWidgetFields({
  disabled,
  isPagesOverlimit,
  typeInProcess,
  onSubmitChangeType,
}) {
  const { t } = useTranslation()

  const { setModal } = useDocFlowContext()

  const options = getDocFlowMappingTypeOptions(t)

  return (
    <FormikField
      {...(isPagesOverlimit
        ? { buttonProps: { tooltip: getPagesOverlimitTooltip() } }
        : null)}
      confirmationChange
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={ButtonSelect}
      changeConfirmationProps={{
        actionButtonsProps: {
          submitText: t('Modal.DocumentStaplingChangeTypeConfirmBtnKey'),
        },
        description: t('DocumentStapling.ChangeTypeAttentionModalTextKey'),
      }}
      controlProps={{
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
      disabled={disabled || typeInProcess || isPagesOverlimit}
      fieldComponentProps={{
        label: t('DocumentStapling.SplittingPhaseTypeFieldTitleKey'),
      }}
      name={DOC_FLOW_FORM_FIELD_TYPE}
      options={options}
      setModal={setModal}
      onChange={onSubmitChangeType}
    />
  )
}

export default DocFlowMappingTypeWidgetFields
